<template>
    <div id="app" class="font-primary" >

        <div class="loading-wrapper" v-if="!loaded" >
            <spinner class="mt-0" ></spinner>
        </div>

        <nav class="left-nav font-size-16" v-if="isAuthenticated" >

            <div class="col-12 logo text-center mt-md-5 mb-md-5 logo" >
                <img src="@/assets/logo.png"  class="mt-2 col-12 logo-img" style="padding: 0;" />
            </div>


            <div class="text-center position-absolute w-100 bottom-0 navbar-bottom-links d-none d-md-block" >

                <a class="cursor-pointer ml-2 mr-2" href="https://theatlass.com/resources" target="_blank" rel="noreferrer" :id="`tooltip--navbar-bottom-links-resources`" > <font-awesome-icon :icon="['far', 'file-alt']" /> </a>
                <b-tooltip :target="`tooltip--navbar-bottom-links-resources`" placement="top" triggers="hover" custom-class="tooltip-narrow" >
                    Check out our resources and docs
                </b-tooltip>

                <a class="cursor-pointer ml-2 mr-2" @click="fModalOpen(true, 'notifications')" :id="`tooltip--navbar-bottom-links-notifications`" >
                    <font-awesome-icon :icon="['far', 'bell']" />
                    <span v-if="appNotifications.filter(x => x.Status=='unread').length > 0" class="badge badge-danger badge-pill badge-appnotifications" > {{ appNotifications.filter(x => x.Status=='unread').length }} </span>
                </a>
                <b-tooltip :target="`tooltip--navbar-bottom-links-notifications`" placement="top" triggers="hover" custom-class="tooltip-narrow" >
                    See latest notifications
                </b-tooltip>

            </div>

            <b-nav vertical class="w-100 mt-mb-5 mt-md-5 flex-wrap-scroll">

                <!--
                <b-nav-item active >
                    <router-link :to="{name: 'Overview'}" > <span class="menu-icon" > <font-awesome-icon icon="chart-pie" /> </span> Overview  </router-link>
                </b-nav-item>

                <b-nav-item v-if="hasTrackingEnabled" >
                    <router-link :to="{name: 'Analyze'}" > <span class="menu-icon" > <font-awesome-icon icon="chart-bar" /> </span> Analyze  </router-link>
                </b-nav-item>

                <b-nav-item v-if="hasTrackingEnabled" >
                    <router-link :to="{name: 'Leads'}" :class="{ 'active': $route.path.includes('customers') || $route.path.includes('lead') }" > <span class="menu-icon" > <font-awesome-icon icon="users" /> </span> Leads  </router-link>
                </b-nav-item>

                <b-nav-item v-if="hasTrackingEnabled" >
                    <router-link :to="{name: 'Setup'}" > <span class="menu-icon" > <font-awesome-icon icon="plug" /> </span> Setup  </router-link>
                </b-nav-item>

                <b-nav-item href="https://theatlass.com/resources" target="_blank" class="d-md-none" >
                    <a href="https://theatlass.com/resources" target="_blank" > <span class="menu-icon" > <font-awesome-icon :icon="['fab', 'dochub']" /> </span> Resouces  </a>
                </b-nav-item>
                -->

                <b-nav-item active  >
                    <router-link :to="{name: 'Onboarding'}" > <span class="menu-icon" > <font-awesome-icon :icon="['fas', 'home']" /> </span> Welcome  </router-link>
                </b-nav-item>

                <b-nav-item class="admin-router " >
                    <router-link :to="{name: 'Academy'}" > <span class="menu-icon" > <font-awesome-icon :icon="['fas', 'graduation-cap']" /> </span> Academy  </router-link>
                </b-nav-item>

                <b-nav-item >
                    <router-link :to="{name: 'Settings'}" > <span class="menu-icon" > <font-awesome-icon icon="cog" /> </span>  Settings  </router-link>
                </b-nav-item>

                <b-nav-item v-if="!getLoggedInOrganization && userRole == 0" class="admin-router d-none d-md-block" >
                    <router-link :to="{name: 'Admin'}" > <span class="menu-icon" > <font-awesome-icon :icon="['fab', 'angular']" /> </span> Admin  </router-link>
                </b-nav-item>

                <b-nav-item >
                    <a @click="logout()" class="nav-item" > <span class="menu-icon" > <font-awesome-icon icon="sign-out-alt" /> </span>  Log out  </a>
                </b-nav-item>

            </b-nav>

            <!-- IF ADMIN IS LOGGED INTO ORGANIZATION -->
            <div class="col-12 adminLoggedIn d-none d-md-block text-center mt-5" v-if="getLoggedInOrganization" >
                <font-awesome-icon :icon="['fab', 'angular']" class="AdminIcon" />
                <div class="adminLoggedIn-data" >
                    {{ adminUsername }} for <br>
                    <b class="font-secondary font-700 font-size-16" > {{ getLoggedInOrganizationName }} </b>
                    <a @click="logoutAdmin()" class="logoutAdmin Text-color--white font-size-16" >  <font-awesome-icon icon="sign-out-alt" />  </a>
                </div>
            </div>
            <!-- IF ADMIN IS LOGGED INTO ORGANIZATION -->

        </nav>

        <main v-bind:class="{ mainLogged: isAuthenticated }" >
            <router-view/>
        </main>

        <modal :modalData="modalData" :modalState="modalState" :modalComponent="modalComponent" :modalDismissable="modalDismissable" ></modal>

    </div>
</template>

<script>
import { AUTH_LOGOUT, LOGOUT_ORG } from '@/store/actions/auth'
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import jwt_decode from "jwt-decode";
import axios from 'axios'
import modal from '@/components/modal.vue'
import helper from '@/helpers/helpers.js';

export default {
    name: 'App',
    data () {
        return {
            loaded: false,
            LoggedInOrganization: null,
            modalData: null,
            modalState: false,
            modalDismissable: true,
            modalComponent: "billing",
            appNotifications: []
        }
    }, //end data
    components:{
        modal
    },
    created: function () {

        //console.log( process.env.ROOT_DOMAIN  );

        //  hook the progress bar to start before we move router-view
        //firebase login
        /*
        this.$router.beforeEach((to, from, next) => {
            //  start the progress bar

            const currentUser = this.$firebase.auth().currentUser
            const requiresAuth = to.matched.some( record => record.meta.requiresAuth )
            const requiresAdmin = to.matched.some( record => record.meta.requiresAdmin )
            const requiresSuperadmin = to.matched.some( record => record.meta.requiresSuperadmin )

            //  does the page we want to go to have a meta.progress object
            if( ( from.path == '/login' && this.$route.path != '/create-account' ) || ( from.name == 'Organization' && to.name == 'Analyze' && this.getLoggedInOrganization ) ){
                this.loaded = false;
            }

            if( from.path == '/login' ){
                this.loaded = false
            }


            if( requiresAuth && !currentUser ){
                next('login')
            }else if( !requiresAuth && currentUser ){
                next()
            }else{
                next()
            }

        })
        */

        this.$router.beforeEach((to, from, next) => {
            //  start the progress bar
            //console.log(to)
            //console.log(from)
            if( from.path == '/login' || to.path == '/logout' ){
                this.loaded = false
            }

            if(to.matched.some(record => record.meta.requiresAuth)) {
                if ( !this.isAuthenticated && this.$route.path != '/create-account' ) {


                    if( this.$route.path != '/create-account' ){
                        this.$router.push({ name: 'Login'});
                    }

                }else{
                    next()
                }
            }else if(to.matched.some(record => record.meta.requiresAdmin)) {

                if( this.isAdmin ){
                    next()
                }
                else{
                    next({ name: 'Home'})
                }

            }else {
                next()
            }

        })

        //  hook the progress bar to finish after we've finished moving router-view
        this.$router.afterEach((to, from) => {
           this.hideloader();
        })

        //this.getStripeData()
        //this.getAppNotifications()

        //console.log( this.$route.path )
    },
    mounted() {

        //console.log( this.$route.path )
        if( this.$route.path == "/login" || this.$route.path == "/create-account"  ){
            this.hideloader();
        }
        this.hideloader();
    },
    methods:{
        logout: function () {
            this.loaded = false;
            this.$store.dispatch(AUTH_LOGOUT).then(() => {

            })
            //this.$router.push({ name: 'Logout'})

        },
        hideloader: function () {
            setTimeout(()=>{ this.loaded = true; },1400);
        },
        logoutAdmin:function(){
            let org = Cookies.get('atlass_lio')
            org = JSON.parse( atob( org ) )
            let orgID = org.ID
            Cookies.remove('atlass_lio')
            this.LoggedInOrganization = null
            this.loaded = false
            //this.$router.push({ name: 'Organization', params: { ID: orgID } });
            this.$store.dispatch(LOGOUT_ORG, org ).then(response => {  })

        },

        getStripeData: async function(){

            let user =  Cookies.get('user')
            if( user ){

                user = JSON.parse( atob( user ) )

                if( user.organization.skip_billing == true ){
                    console.log("billing skipped")
                    return true
                }
                let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', 'X_AUTH_TOKEN': Cookies.get('user-token') }

                return await axios({
                    method: 'post',
                    url: process.env.ROOT_API+'/billing',
                    headers: headers,
                    data: {
                        "email": user.email,
                    }
                })
                .then(resp => {
                    let data = resp.data
                    //console.log(user)
                    //console.log(data)

                    if( !data || ( data && data.subscription.length == 0 ) ){
                        //console.log( user.datetime + ( 60*60*24*14 ) )
                        //console.log( Math.round(+new Date()/1000) )

                        if( ( user.datetime + ( 60*60*24*14 ) ) < Math.round(+new Date()/1000) ){
                            console.log("FORCE set up billing")
                            this.fModalOpen( false )
                        }else{
                            console.log("Prompt set up billing dismissable")
                            this.fModalOpen( true )
                        }
                    }else{
                        console.log("build cases for failed payments")

                        if( data.subscription[0].status != 'trialing' && data.subscription[0].status != 'active' ){
                            this.fModalOpen( true )
                        }
                    }



                })
                .catch(error => {
                    console.log(error)
                }); //end axios

            }//end if user
        },

        getAppNotifications: function(){

            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            var ref = this.$firebase.firestore().collection('organizations/'+orgID+'/notifications').orderBy('datetime', 'desc')

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {
                                let item = {};
                                item = doc.data();
                                item.id = doc.id;

                                results.push(item);
                                //console.log( item )

                                //results.sort((a, b) => b.datetime - a.datetime);

                                this.appNotifications = results


                                return results;

                        })

                    )
                    .then(results => {
                        return results;
                    })

                })

        },

        fModalOpen( dismissable, modalComponent = 'billing' ){
            if(  modalComponent == 'billing' ){

                setTimeout(function(){
                    this.modalState = true;
                    this.modalDismissable = dismissable
                    this.modalComponent = modalComponent
                }.bind(this), 3000 )

            }else{

                if( modalComponent == 'notifications' ){
                    this.modalData = this.appNotifications
                }

                this.modalState = true;
                this.modalDismissable = dismissable
                this.modalComponent = modalComponent



            }

        }

    },
    computed:{
        isAuthenticated() {
            if( this.$store.getters.isAuthenticated && Cookies.get('user') ){
                return true
            }else{

                if( this.$route.meta.requiresAuth ){
                    this.$store.dispatch(AUTH_LOGOUT)
                }
                /*
                if( this.$route.path != '/stats' ){
                    this.$store.dispatch(AUTH_LOGOUT).then(() => {
                        //console.log( this.$route.path  )
                        if( this.$route.path != '/create-account' ){
                            //this.$router.push({ name: 'Login'});
                        }
                    })
                    document.body.classList.remove('guest-stats')
                }else{
                    document.body.classList.add('guest-stats')
                }*/
            }

        },
        isAdmin(){
            if( !this.$store.getters.getLoggedInOrganization  ){
                return this.$store.getters.isAdmin
            }else{
                return false
            }

        },
        userRole(){
            return this.$store.getters.getRole
        },
        getLoggedInOrganizationName(){
            if( this.$store.getters.getLoggedInOrganizationToken  ){
                console.log(  )
                let org = this.$store.getters.getLoggedInOrganizationToken
                org = JSON.parse( atob( org ) )
                return org.name
            }

        },
        adminUsername(){
            let user = Cookies.get('user')
            if( user ){

                //user = JSON.parse( atob( user ) )
                user = jwt_decode(Cookies.get('user-token')).data
                return user.email
            }
            return false
        },
        hasTrackingEnabled(  ){
            if( this.$store.getters.getLoggedInOrganizationToken ){
                let org = this.$store.getters.getLoggedInOrganizationToken
                org = JSON.parse( atob( org ) )
                //org = jwt_decode(Cookies.get('user-token'))
                if( org.settings.tracking == true ){
                    return true
                }else{
                    return false
                }
                return org.settings
            }else{
                return false
            }

        },
        getLoggedInOrganization(){
            //only works on page reload
            /*
            if( Cookies.get('atlass_lio') ){
                return true
            }else{
                return false
            }*/
            //works without page reload

            return this.$store.getters.getLoggedInOrganization
        },
    }
}
</script>

<style lang="scss">
@import '@/assets/css/global.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue